<template>
    <div class="shape-background"></div>
    <div class="curve-shape">
        <svg x="0px" y="0px" viewBox="0 0 3841 120" style="overflow:scroll;
            enable-background:new 0 0 3841 120;" xml:space="preserve">
            <slot name="bgcolor"></slot>
        </svg>
    </div>
</template>

<style lang="scss" scoped>
.curve-shape {
    margin-bottom: -12px;
    overflow-x: hidden;

    svg {
        width: 200%;
        position: relative;
        z-index: 2;
        animation: move-left 6s linear infinite;
    }
}

.shape-background {
    width: 200%;
    height: 100px;
    overflow-y: hidden;
    z-index: 1;
    position: relative;
    background-color: rgb(246, 247, 249);
    margin-bottom: -200px;
}


@keyframes move-left {
    0% {
        left: 0%;
    }

    100% {
        left: -100%;
    }
}
</style>